import BaseEntity from '../database/BaseEntity.js';

/**
 * CanalTV Entity
 * Represents a CanalTV in the system
 *
 * Built-in fields (auto-generated):
 * - id: Unique identifier
 * - createdAt: Creation timestamp
 * - updatedAt: Last update timestamp
 * - createdBy: Email of user who created the record
 */
class CanalTV extends BaseEntity {
  static collectionName = 'canaltvs';
  static _schema = JSON.parse("{\"name\":\"CanalTV\",\"type\":\"object\",\"properties\":{\"nombre\":{\"type\":\"string\",\"description\":\"Nombre del canal de TV\"},\"descripcion\":{\"type\":\"string\",\"description\":\"Descripción del canal\"},\"url_stream\":{\"type\":\"string\",\"description\":\"URL del stream en vivo (m3u8, YouTube embed, etc.)\"},\"tipo_stream\":{\"type\":\"string\",\"enum\":[\"youtube\",\"m3u8\",\"iframe\",\"otro\"],\"default\":\"youtube\",\"description\":\"Tipo de stream\"},\"imagen_portada\":{\"type\":\"string\",\"description\":\"URL de la imagen de portada del canal\"},\"categoria\":{\"type\":\"string\",\"enum\":[\"noticias\",\"entretenimiento\",\"deportes\",\"musica\",\"peliculas\",\"infantil\",\"otro\"],\"default\":\"entretenimiento\",\"description\":\"Categoría del canal\"},\"activo\":{\"type\":\"boolean\",\"default\":true,\"description\":\"Si el canal está activo\"},\"orden\":{\"type\":\"number\",\"default\":0,\"description\":\"Orden de aparición\"}},\"required\":[\"nombre\",\"url_stream\"]}");
}

export { CanalTV };
export default CanalTV;
